import { format } from 'date-fns';
import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  ma_ngv: z.string().optional(),
  ma_gd: z.string().optional(),
  dien_giai: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialSearchValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  ma_ngv: 'ALL',
  ma_gd: 'ALL',
  dien_giai: '',
  status: 'ALL',
  user_id0: 'ALL'
};

export const formSchema = z.object({
  so_buoc: z.string().optional().nullable(),
  ma_gd: z.string().optional().nullable(),
  dien_giai: z.string().optional().nullable(),
  so_ct: z.string().optional().nullable(),
  ngay_ct: z.string().optional().nullable(),
  ma_nt: z.string().optional().nullable(),
  ty_gia: z.coerce.number().optional().nullable(),
  status: z.string().optional().nullable(),
  transfer_yn: z.boolean().optional().nullable(),
  ma_tthddt: z.string().optional().nullable(),
  ma_pttt: z.string().optional().nullable(),
  so_ct_hddt: z.string().optional().nullable(),
  lenh_dd: z.string().optional().nullable(),
  ngay_ct_hddt: z.string().optional().nullable(),
  so_ct2_hddt: z.string().optional().nullable(),
  ngay_dd: z.string().optional().nullable(),
  ma_mau_ct_hddt: z.string().optional().nullable(),
  nguoi_dd: z.string().optional().nullable(),
  viec_dd: z.string().optional().nullable(),
  so_hd_vc: z.string().optional().nullable(),
  ly_do_huy: z.string().optional().nullable(),
  ly_do: z.string().optional().nullable()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  so_buoc: '1',
  ma_gd: '',
  dien_giai: null,
  so_ct: null,
  ngay_ct: new Date().toISOString().split('T')[0],
  ma_pttt: null,
  ma_nt: null,
  ty_gia: 1,
  status: '5',
  transfer_yn: false,
  ma_tthddt: '0',
  so_ct_hddt: null,
  lenh_dd: null,
  ngay_ct_hddt: new Date().toISOString().split('T')[0],
  so_ct2_hddt: null,
  ngay_dd: new Date().toISOString().split('T')[0],
  ma_mau_ct_hddt: null,
  nguoi_dd: null,
  viec_dd: null,
  so_hd_vc: null,
  ly_do_huy: null,
  ly_do: null
};
